import { Injectable } from "@angular/core";
import { Preferences } from "@capacitor/preferences";

import { StorageKey } from "../models";
import { UserTenantId } from "../models/user-tenant.model";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  constructor() {}

  async set(key: StorageKey, value: any): Promise<void> {
    await Preferences.set({
      key: key,
      value: `${value}`,
    });
  }

  /**
   *
   * @param key
   * @returns
   */
  async getString(key: StorageKey): Promise<string | null> {
    var result = await Preferences.get({ key });
    return result.value;
  }

  /**
   * Returns value parsed as number or null
   * @param key
   * @returns
   */
  async getNumber(key: StorageKey): Promise<number | null> {
    const { value } = await Preferences.get({ key });
    if (value === undefined || value === null || isNaN(Number(value))) {
      return null;
    } else {
      return Number(value);
    }
  }

  async storeTenantKeys(data: UserTenantId[]): Promise<void> {
    for (const item of data) {
      await Preferences.set({
        key: item.tGuid,
        value: `${item.tenantId}`,
      });
    }
  }

  /**
   * Return the database number
   *
   * - Tests the provided URL from the active route
   * - Then tries locally
   *
   * @returns {number} tenantId
   */
  async getTenantId(tenantGuid?: string | null): Promise<number | null> {
    // check active route,
    let tGuid: string | null = tenantGuid || null;

    if (tGuid === null) {
      // if no good, check local storage for default
      tGuid = await this.getString(StorageKey.defaultTenantGuid);
      if (tGuid === null) {
        // still no good, return null
        return null;
      }
    }

    const { value } = await Preferences.get({ key: tGuid });
    if (value === undefined || value === null || isNaN(Number(value))) {
      return null;
    } else {
      return Number(value);
    }
  }

  /**
   * Clear all saved preferences
   */
  async clear(): Promise<void> {
    await Preferences.clear();
  }
}
